// This is the splash page for the desktop site
// ----------------------------------------------------------------------------

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import classnames from "classnames";

import Link from "shared/components/Link";
import Str from "shared/components/Str";
import Context from "shared/util/Context";

import { FACEBOOK_SIGNUP_STATES, URLS } from "apps/signup/util/constants";

import TermsOfService from "shared/components/TermsOfService";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Top from "./components/Top";
import {
	loadSplash,
	CONFIRM_RECAPTCHA_SUCCESS,
} from "ducks/splash";
import { confirmToken } from "ducks/recaptcha";

import {
	APPLE_LINK,
	ANDROID_LINK,
} from "shared/dictionaries/app_store_campaigns.js";

import "./App.scss";

const isIndia = Context.has("INDIAN_SPLASH_PAGES");
const DESIGN_REFRESH_PERIOD = 5000;
const DESIGNS = isIndia
	? ["find-my-kind"]
	: ["hands", "facepaint", "rose", "couch", "eyemasks"];

function getDesign(currentDesign) {
	let nextDesign = DESIGNS[Math.floor(Math.random() * DESIGNS.length)];

	DESIGNS.forEach((design, i) => {
		if (design === currentDesign) {
			// try to load the next one
			nextDesign = DESIGNS[i + 1] || DESIGNS[0];
		}
	});

	return nextDesign;
}


class SplashDtf extends React.Component {
	static propTypes = {
		facebookState: PropTypes.string,
		confirmRecaptchaToken: PropTypes.func.isRequired,
		loadSplash: PropTypes.func.isRequired,
	};

	state = {
		design: getDesign(),
		stopCarousel: false,
		timeoutId: null,
		recaptchaToken: null,
		isIndia,
	};

	componentDidMount() {
		this.props.loadSplash();

		if (this.state.isIndia) {
			return;
		}

		this._resetDesignSoon();

		window.addEventListener("hashchange", () => {
			const hash = window.location.hash.replace("#", "");

			if (DESIGNS.indexOf(hash) === -1) {
				return;
			}

			this.setState({
				design: hash,
				stopCarousel: true,
			});
		});
	}

	componentWillUnmount() {
		if (this.state.timeoutId) {
			window.clearTimeout(this.state.timeoutId);
		}
	}

	_resetDesignSoon = () => {
		const timeoutId = setTimeout(() => {
			this._resetDesign();
		}, DESIGN_REFRESH_PERIOD);

		this.setState({ timeoutId });
	};

	_resetDesign = () => {
		const { facebookState } = this.props;
		const hasFacebook = facebookState === FACEBOOK_SIGNUP_STATES.success;

		// only do this on the first page
		if (hasFacebook) {
			return;
		}

		if (this.state.stopCarousel) {
			return;
		}

		// set a new design
		this.setState({ design: getDesign(this.state.design) });

		// re-roll later
		this._resetDesignSoon();
	};

	_trackRecaptchaScore = () => {
		const { confirmRecaptchaToken } = this.props;
		const { recaptchaToken } = this.state;
		confirmRecaptchaToken({
			type: CONFIRM_RECAPTCHA_SUCCESS,
			token: recaptchaToken,
			isCaptchaShowing: false,
			page: "splash",
		});
	}

	render() {
		const {
			facebookState,
		} = this.props;
		const { design } = this.state;

		const hasFacebook = facebookState === FACEBOOK_SIGNUP_STATES.success;

		return (
			<div
				className={classnames("splashdtf", {
					[`splashdtf--${design}`]: true,
				})}
			>
				<div className="splashdtf-content">
					<Header />

					{!hasFacebook &&
						<Fragment>
							<Top />
							<div className="splashdtf-hero">
								{DESIGNS.map((name) => (
									<div
										key={name}
										className={`splashdtf-hero-image splashdtf-hero-image--${name}`}
									/>
								))}
							</div>
						</Fragment>
					}

					<div className="splashdtf-tos">
						<TermsOfService />
					</div>

					<div className="splashdtf-signupcontainer">
						<Link
							className="splashdtf-signup-button"
							to={URLS.SIGNUP}
							onClick={this._trackRecaptchaScore}
						>
							<Str>Join OkCupid</Str>
						</Link>
					</div>

					<div className="splashdtf-mobile">
						<Str className="splashdtf-mobile-text">Get the app</Str>
						<a
							className="splashdtf-mobile-buttons splashdtf-mobile-buttons--googleplay"
							href={ANDROID_LINK("desktophome")}>
							Google Play
						</a>
						<a
							className="splashdtf-mobile-buttons splashdtf-mobile-buttons--appstore"
							href={APPLE_LINK("desktophome")}>
							App Store
						</a>
					</div>

					<GoogleReCaptcha
						onVerify={(token) => this.setState({ recaptchaToken: token })}
						action="splash"
					/>
				</div>

				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { splashdtf, signup } = state;
	return { ...splashdtf, ...signup };
}

const mapDispatchToProps = {
	confirmRecaptchaToken: confirmToken,
	loadSplash,
};

export { SplashDtf };
export default connect(mapStateToProps, mapDispatchToProps)(SplashDtf);



// WEBPACK FOOTER //
// ./src/apps/splash_desktop/App.jsx